import React from 'react';
import { INSTITUTIONAL_INFO, NAV_LINKS } from '../constants';

const accessLinks = [
  { label: 'Login do Conselheiro', href: '/app/login', icon: 'fas fa-id-card' },
  { label: 'Área do Município', href: '/area-restrita/login', icon: 'fas fa-city' },
  { label: 'Painel Admin', href: '/admin/login', icon: 'fas fa-lock' },
];

const socialLinks = [
  { label: 'Instagram', href: 'https://www.instagram.com/rs.aconturs/', icon: 'fab fa-instagram' },
  { label: 'Facebook', href: 'https://www.facebook.com/ACONTURS', icon: 'fab fa-facebook' },
  { label: 'WhatsApp', href: 'https://wa.me/5551982755065', icon: 'fab fa-whatsapp' },
];

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#061d14] text-slate-300 border-t border-brand-yellow/20">
      <div className="container mx-auto px-4 py-12 lg:py-14">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1.2fr)_minmax(180px,0.7fr)_minmax(220px,0.8fr)_minmax(240px,0.9fr)]">
          <div>
            <div className="mb-4 flex items-center gap-3">
              <img
                src="/assets/logo_litoral.png"
                alt="Logo ACONTURS Litoral"
                className="h-16 w-auto object-contain"
              />
              <div>
                <strong className="block text-xl font-black tracking-widest text-white">ACONTURS</strong>
                <span className="text-sm font-bold uppercase tracking-widest text-brand-yellow">Litoral Norte</span>
              </div>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-slate-400">
              {INSTITUTIONAL_INFO.fullTitle}. Representação, formação e articulação regional para fortalecer os Conselhos Tutelares do litoral gaúcho.
            </p>
          </div>

          <div>
            <h2 className="mb-4 text-xs font-black uppercase tracking-widest text-brand-yellow">Landing page</h2>
            <nav className="space-y-3" aria-label="Links do rodapé">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-sm font-semibold text-slate-300 transition hover:text-white"
                >
                  {link.name}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h2 className="mb-4 text-xs font-black uppercase tracking-widest text-brand-yellow">Acessos</h2>
            <div className="space-y-3">
              {accessLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="flex min-h-11 items-center gap-3 rounded-lg border border-white/10 bg-white/[0.03] px-3 text-sm font-bold text-white transition hover:border-brand-yellow/50 hover:bg-white/[0.07]"
                >
                  <i className={`${link.icon} w-4 text-brand-yellow`}></i>
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h2 className="mb-4 text-xs font-black uppercase tracking-widest text-brand-yellow">Contato</h2>
            <div className="space-y-3 text-sm text-slate-300">
              <a href="mailto:contato@aconturslitoral.com.br" className="flex items-center gap-3 transition hover:text-white">
                <i className="fas fa-envelope w-4 text-brand-yellow"></i>
                contato@aconturslitoral.com.br
              </a>
              <a href="https://wa.me/5551982755065" target="_blank" rel="noreferrer" className="flex items-center gap-3 transition hover:text-white">
                <i className="fab fa-whatsapp w-4 text-brand-yellow"></i>
                WhatsApp institucional
              </a>
              <div className="flex items-center gap-3">
                <i className="fas fa-map-pin w-4 text-brand-yellow"></i>
                Tramandaí / RS
              </div>
            </div>

            <div className="mt-5 flex gap-2">
              {socialLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 bg-white/[0.04] text-slate-200 transition hover:border-brand-yellow hover:bg-brand-yellow hover:text-brand-darkGreen"
                  aria-label={link.label}
                >
                  <i className={link.icon}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 bg-black/20">
        <div className="container mx-auto flex flex-col gap-2 px-4 py-4 text-xs font-semibold text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; 2026 ACONTURS Litoral Norte. Todos os direitos reservados.</p>
          <p>Comunicação: Wagner Macedo</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
